import React from "react";
import { Link } from "react-router-dom";
import { Globe, Mail } from "lucide-react";

/**
 * Footer — clean, no logo image (logo lives only in nav + hero).
 * Wordmark text only, hairline divider, three columns of meta.
 */
const FOOTER_LINKS = [
  { to: "/platform", label: "Cockpit VNG Mienskip", testid: "footer-platform" },
  { to: "/register", label: "Register", testid: "footer-register" },
  {
    to: "/publiek-overzicht",
    label: "Publiek register",
    testid: "footer-public",
  },
  { to: "/kaders", label: "Kaders", testid: "footer-kaders" },
  { to: "/team", label: "Team", testid: "footer-team" },
];

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-[#C0C5CE]/20 mt-32"
  >
    <div className="rk-container py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <Link
          to="/"
          data-testid="footer-brand"
          className="inline-block leading-tight"
        >
          <div
            className="text-2xl tracking-tight text-white rk-wordmark"
            style={{ fontFamily: "Fraunces, serif", fontWeight: 400 }}
          >
            RiskaiΛ
          </div>
          <div className="overline text-[10px] mt-1">
            Ethics &amp; Transparency
          </div>
        </Link>
        <p className="mt-5 text-sm text-[#9AA4B2] max-w-md leading-relaxed">
          Het continue toezicht­platform voor algoritmes en AI bij Nederlandse
          gemeenten. Gebouwd rondom het VNG-kader, de AI-Verordening en het
          Algoritmeregister.
        </p>
      </div>

      <div className="md:col-span-3">
        <div className="overline mb-3">Navigatie</div>
        <div className="h-px bg-[#C0C5CE]/25 mb-5" aria-hidden />
        <ul className="space-y-2.5 text-sm text-[#D4D8DF]">
          {FOOTER_LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                className="hover:text-white"
                data-testid={l.testid}
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-4">
        <div className="overline mb-3">Contact</div>
        <div className="h-px bg-[#C0C5CE]/25 mb-5" aria-hidden />
        <ul className="space-y-3 text-sm text-[#D4D8DF]">
          <li className="flex items-start gap-3">
            <Globe
              strokeWidth={1}
              className="w-4 h-4 mt-0.5 text-[#C0C5CE] shrink-0"
            />
            <a
              href="https://www.riskaia.com"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white"
              data-testid="footer-website"
            >
              www.riskaia.com
            </a>
          </li>
          <li className="flex items-start gap-3">
            <Mail
              strokeWidth={1}
              className="w-4 h-4 mt-0.5 text-[#C0C5CE] shrink-0"
            />
            <a
              href="mailto:info@riskaia.com"
              className="hover:text-white"
              data-testid="footer-email"
            >
              info@riskaia.com
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div className="hairline" />
    <div className="rk-container py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#9AA4B2]">
      <div>
        © {new Date().getFullYear()}{" "}
        <span className="rk-wordmark">RiskaiΛ</span> B.V. — Alle rechten
        voorbehouden.
      </div>
      <div className="tracking-[0.2em] uppercase">
        Final Handover · Leeuwarden Edition
      </div>
    </div>
  </footer>
);

export default Footer;
